import Backbone from "backbone";

export default Backbone.View.extend({

    initialize: function () {
      this.isActive = false;
    },

    events: {
      'click .js-togglebestSales': 'render',
    },

    render: function (event) {
      switch(this.isActive) {
        case true:
          this.$el.removeClass("isActive");
          this.isActive = false;
          break;
        case false:
          this.$el.addClass("isActive");
          this.isActive = true;
          break;
        default:
          this.isActive = false;
      }
    }

  });
